import { render, staticRenderFns } from "./CustomerShowQuotation.vue?vue&type=template&id=4d8de5b4"
import script from "./CustomerShowQuotation.vue?vue&type=script&lang=js"
export * from "./CustomerShowQuotation.vue?vue&type=script&lang=js"
import style0 from "./CustomerShowQuotation.vue?vue&type=style&index=0&id=4d8de5b4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports